import React from 'react'
import { TouchableOpacity } from 'react-native'
import AppText from './AppText';
import { THEME_COLORS } from '@common/themes';

const ClearFilter = ({ onClearFilter }: { onClearFilter: () => void }): JSX.Element => {

    return (
        <TouchableOpacity style = {{ position: 'absolute', width: 15, height: 15, top: -7.5, right: -7.5, borderRadius: 8, backgroundColor: '#6300A3', alignItems: 'center', justifyContent: 'center' }}
        onPress = { onClearFilter }>
            <AppText fontSize={9} color={THEME_COLORS.white} fontFamily="bold" textAlign="center">
                X
            </AppText>
        </TouchableOpacity>
    )

}

export default ClearFilter
